// Vue
import Vue from "vue";

// Components
import { ContentModule } from "#/modules/common/content_module/ContentModule";
import { GalleryModule } from "#/modules/common/gallery_module/GalleryModule";
import { MasonryModule } from "#/modules/common/masonry_module/MasonryModule";
import { NotImplementedModule } from "#/modules/common/not_implemented_module/NotImplementedModule";
import { MoreInformationHeader } from "#/modules/common/more_information_header/MoreInformationHeader";
import { MoreInformationFooter } from "#/modules/common/more_information_footer/MoreInformationFooter";
import { MoreInformation } from "#/modules/common/more_information/MoreInformation";
import { TextBildModule } from "#/modules/aufbauplus/text_bild_module/TextBildModule";
import { PiOverviewModule } from "#/modules/common/pi_overview_module/PiOverviewModule";
import { PiLayerWrapperModule } from "#/modules/common/pi_layer_wrapper_module/PiLayerWrapperModule";
import { PiLayerSeparatorModule } from "#/modules/common/pi_layer_separator_module/PiLayerSeparatorModule";
import { PiLayerFooterModule } from "#/modules/common/pi_layer_footer_module/PiLayerFooterModule";
import { PiLayerHeaderModule } from "#/modules/common/pi_layer_header_module/PiLayerHeaderModule";
import { DownloadModule } from "#/modules/common/download_module/DownloadModule";
import { MultiColumnTextAndImageModule } from "#/modules/common/multicolumn_text_and_image_module/MultiColumnTextAndImageModule";
import { AnchorModule } from "#/modules/common/anchor_module/AnchorModule";
import { VideoModule } from "#/modules/common/video_module/VideoModule";
import { TabsContentTableModule } from "#/modules/common/tabs_content_table_module/TabsContentTableModule";
import { CwLandingpageTeaserModule } from "#/modules/common/cw_landingpage_teaser_module/CwLandingpageTeaserModule";
import { QuoteModule } from "#/modules/common/quote_module/QuoteModule";
import { StageModule } from "#/modules/common/stage_module/StageModule";
import { AppointmentModule } from "#/modules/common/appointment_module/AppointmentModule";
import { ContentHighlightModule } from "#/modules/common/content_highlight_module/ContentHighlightModule";
import { ContactModule } from "#/modules/common/contact_module/ContactModule";
import { ImageSitemapModule } from "#/modules/common/image_sitemap_module/ImageSitemapModule";
import { TabHeaderModule } from "#/modules/common/tab_header_module/TabHeaderModule";
import { TabFooterModule } from "#/modules/common/tab_footer_module/TabFooterModule";
import { TabElementModule } from "#/modules/common/tab_element_module/TabElementModule";
import { TabsModule } from "#/modules/common/tabs_module/TabsModule";
import { TabModule } from "#/modules/common/tab_module/TabModule";
import { ContentAdvantageModule } from "#/modules/common/content_advantage_module/ContentAdvantageModule";
import { TeaserModule } from "#/modules/common/teaser_module/TeaserModule";
import { BranchenAnchorModule } from "#/modules/common/branchen_anchor_module/BranchenAnchorModule";
import { ModelSelectionModule } from "#/modules/katalog/model_selection_module/ModelSelectionModule";
import { ModelSelectionFilterModule } from "#/modules/katalog/model_selection_filter_module/ModelSelectionFilterModule";
import { KachelPreviewModule } from "#/modules/katalog/kachel_preview_module/KachelPreviewModule";
import { NoticeModule } from "#/modules/common/notice_module/NoticeModule";
import { TypeSelectionModule } from "#/modules/katalog/type_selection_module/TypeSelectionModule";
import { PfDashboardModule } from "#/modules/katalog/pf_dashboard_module/PfDashboardModule";
import { KatalogTabelleModule } from "#/modules/katalog/katalog_tabelle_module/KatalogTabelleModule";
import { KatalogSelectionModule } from "#/modules/katalog/katalog_selection_module/KatalogSelectionModule";
import { KennzahlenModule } from "./common/kennzahlen_module/KennzahlenModule";
import { Highlight360Module } from "./common/highlight360_module/Highlight360Module";
import { HighlightSliderModule } from "./common/highlight_slider_module/HighlightSliderModule";
import { OrganizationChartModule } from "#/modules/common/organization_chart_module/OrganizationChartModule";
import { KeyFiguresModule } from "#/modules/common/key_figures_module/KeyFiguresModule";
import { NewsListModule } from "#/modules/common/news_list_module/NewsListModule";
import { StickyAnchorModule } from "#/modules/common/sticky_anchor_module/StickyAnchorModule";
import { CwTextBildModule } from "#/modules/common/cw_text_bild_module/CwTextBildModule";
import { PfKatalogAufbaurichtlinienModule } from "#/modules/katalog/pf_katalog_aufbaurichtlinien_module/PfKatalogAufbaurichtlinienModule";
import { NewsPreviewModule } from "./common/news_preview_module/NewsPreviewModule";
import { ProductListVanSolutionModule } from "./conversionworld/product_list/product_list_van_solution_module/ProductListVanSolutionModule";
import { ProductListVanPartnerModule } from "./conversionworld/product_list/product_list_van_partner_module/ProductListVanPartnerModule";
import { TableModule } from "./common/table_module/TableModule";
import { RechtlicheKlausel } from "./katalog/rechtliche_klausel/RechtlicheKlausel";
import { RechtlicheKlauselHeader } from "./katalog/rechtliche_klausel_header/RechtlicheKlauselHeader";
import { RechtlicheKlauselFooter } from "./katalog/rechtliche_klausel_footer/RechtlicheKlauselFooter";
import { RechtlicheKlauselSeparator } from "./katalog/rechtliche_klausel_separator/RechtlicheKlauselSeparator";
import { FileExchangeModule } from "./katalog/file_exchange/FileExchange";
import { BreadcrumbModule } from "./common/breadcrumb_module/BreadcrumbModule";
import { NextStepNavigationModule } from "./common/next_step_navigation_module/NextStepNavigationModule";
import { CWLandingpageMesseTeaserModul } from "./common/cw_landingpage_messe_teaser_modul/CWLandingpageMesseTeaserModul";
import { DefaultLayout } from "./layout/default_layout/DefaultLayout";
import { AufbauplusLayout } from "./layout/aufbauplus_layout/AufbauplusLayout";
import { LoadingLayout } from "./layout/loading_layout/LoadingLayout";
import { ReferenceContentModule } from "./common/reference_content_module/ReferenceContentModule";
import { IframeModule } from "./common/iframe_module/IframeModule";
import { ModalHeaderModule } from "./common/modal_header_module/ModalHeaderModule";
import { ModalFooterModule } from "./common/modal_footer_module/ModalFooterModule";
import { ModalModule } from "./common/modal_module/ModalModule";
import { RechtlicheHinweiseLayout } from "./layout/rechtliche_hinweise_layout/RechtlicheHinweiseLayout";
import { CWInteriorSpinWidget } from "./common/cw_interior_spin_widget/CWInteriorSpinWidget";
import { BreadcrumbKatalogModule } from "./katalog/breadcrumb_katalog_module/BreadcrumbKatalogModule";
import { PiDetailsWidget } from "./common/pi_details_widget/PiDetailsWidget";
import { WarenkorbModule } from "./katalog/warenkorb_module/WarenkorbModule";
import { FinArchivModule } from "./katalog/fin_archiv_module/FinArchivModule";
import { ProductFastFilterModule } from "./unimog/product_fast_filter_module/ProductFastFilterModule";
import { PageFilterModule } from "./unimog/page_filter_module/PageFilterModule";
import { PageProductModule } from "./unimog/page_product_module/PageProductModule";
import { PagePartnerModule } from "./unimog/page_partner_module/PagePartnerModule";
import { HaendlersucheModule } from "./unimog/haendlersuche_module/HaendlersucheModule";
import { UnimogLayout } from "./layout/unimog_layout/UnimogLayout";
import { ModellbeschreibungPflegeModule } from "./katalog/modellbeschreibung_pflege_module/ModellbeschreibungPflegeModule";
import { ModellbeschreibungAnzeigeModule } from "./katalog/modellbeschreibung_anzeige_module/ModellbeschreibungAnzeigeModule";
import { MapModule } from "./common/map_module/MapModule";
import { MatomoOptOutModule } from "./common/matomo_opt_out_module/MatomoOptOutModule";
import { AbhOverviewPageModule } from "./conversionworld/abh_overview_page_module/AbhOverviewPageModule";
import { AbhSteckbriefKontaktModule } from "./conversionworld/abh_steckbrief_kontakt_module/AbhSteckbriefKontaktModule";
import { AbhCertificateModule } from "./conversionworld/abh_certificate_module/AbhCertificateModule";
import { ConversionworldLayout } from "./layout/conversionworld_layout/ConversionworldLayout";
import { SeoPortraitModule } from "./conversionworld/seo_portrait_module/SeoPortraitModule";
import { AbhFirmenphilosophieModule } from "./conversionworld/abh_firmenphilosophie_module/AbhFirmenphilosophieModule";
import { AbhProductsModule } from "./conversionworld/abh_products_module/AbhProductsModule";
import { AbhReportsModule } from "./conversionworld/abh_reports_module/AbhReportsModule";
import { ProductTextModule } from "./conversionworld/product_text_module/ProductTextModule";
import { BranchenEinstiegModule } from "./conversionworld/branchen_einstieg_module/BranchenEinstiegModule";
import { SoftconfiguratorModule } from "./conversionworld/softconfigurator_module/SoftconfiguratorModule";
import { FilterModule } from "./conversionworld/filter_module/FilterModule";
import { ProductStageModule } from "./conversionworld/product_stage_module/ProductStageModule";
import { ProductTechnicalData } from "./conversionworld/product_technical_data/ProductTechnicalData";
import { ProductNextStepNavigationModule } from "./conversionworld/product_next_step_navigation_module/ProductNextStepNavigationModule";
import { ProductAdvantagesModule } from "./conversionworld/product_advantages_module/ProductAdvantagesModule";
import { ProductMinimumEquipmentModule } from "./conversionworld/product_minimum_equipment_module/ProductMinimumEquipmentModule";
import { ProductBodybuilderTeaserModule } from "./conversionworld/product_bodybuilder_teaser_module/ProductBodybuilderTeaserModule";
import { ProductPartnerAdvantagesAutomaticModule } from "./conversionworld/product_partner_advantages_module/product_partner_advantages_automatic_module/ProductPartnerAdvantagesAutomaticModule";
import { ProductPartnerAdvantagesManuelModule } from "./conversionworld/product_partner_advantages_module/product_partner_advantages_manual_module/ProductPartnerAdvantagesManuelModule";
import { ProductPartnerAdvantagesEditModule } from "./conversionworld/product_partner_advantages_module/product_partner_advantages_edit_module/ProductPartnerAdvantagesEditModule";
import { SeoProductModule } from "./conversionworld/seo_product_module/SeoProductModule";
import { PopularSolutionModule } from "./conversionworld/popular_solution_module/PopularSolutionModule";
import { SearchResultModule } from "./conversionworld/search_result_module/SearchResultModule";
import { StageFrontpageAnimationModule } from "./conversionworld/stage_frontpage_animation_module/StageFrontpageAnimationModule";
import { StageBrancheModule } from "./conversionworld/stage_branche_module/StageBrancheModule";
import { StageSoftConfiguratorModule } from "./conversionworld/stage_soft_configurator_module/StageSoftConfiguratorModule";
import { ReportsModule } from "./conversionworld/reports_module/ReportsModule";
import { ReportInformationModule } from "./conversionworld/report_information_module/ReportInformationModule";
import { SeoReportModule } from "./conversionworld/seo_report_module/SeoReportModule";
import { ReportNbaModule } from "./conversionworld/report_nba_module/ReportNbaModule";
import { TeaserModule as CWTeaserModule } from "./conversionworld/teaser_module/TeaserModule";
import { KonsiListModule } from "./conversionworld/konsi_list_module/KonsiListModule";
import { KonsiSliderModule } from "./conversionworld/konsi_slider_module/KonsiSliderModule";
import { SeoMesseModule } from "./conversionworld/seo_messe_module/SeoMesseModule";
import { StageFallbackFrontpageModule } from "./conversionworld/stage_fallback_frontpage_module/StageFallbackFrontpageModule";
import { HistoryModule } from "./common/history_module/HistoryModule";
// Utils
let registerModules = (components: { [component: string]: any }) => {
  Object.keys(components).forEach((name) => {
    Vue.component(`Module${name}`, components[name]);
  });
};

registerModules({
  CWSoftconfiguratorWidget: SoftconfiguratorModule,
  AufbauplusTextBildWidget: TextBildModule,
  ContentWidget: ContentModule,
  KennzahlenWidget: KennzahlenModule,
  Highlight360Widget: Highlight360Module,
  HighlightSliderWidget: HighlightSliderModule,
  TabsContentDownloadWidget: DownloadModule,
  GalleryWidget: GalleryModule,
  MasonryWidget: MasonryModule,
  MoreInformation: MoreInformation,
  MoreInformationHeaderWidget: MoreInformationHeader,
  MoreInformationFooterWidget: MoreInformationFooter,
  NotImplementedModule: NotImplementedModule,
  PIOverviewWidget: PiOverviewModule,
  PILayerWrapper: PiLayerWrapperModule,
  PILayerSeparatorWidget: PiLayerSeparatorModule,
  PILayerFooterWidget: PiLayerFooterModule,
  PILayerHeaderWidget: PiLayerHeaderModule,
  MulticolumnTextAndImageWidget: MultiColumnTextAndImageModule,
  AnchorWidget: AnchorModule,
  VideoWidget: VideoModule,
  TabsContentTableWidget: TabsContentTableModule,
  CWLandingpageTeaserModulWidget: CwLandingpageTeaserModule,
  QuoteWidget: QuoteModule,
  StageToolBoxWidget: StageModule,
  AppointmentWidget: AppointmentModule,
  ContentHighlightWidget: ContentHighlightModule,
  TabsContentContactWidget: ContactModule,
  ImageSitemapWidget: ImageSitemapModule,
  TabHeaderWidget: TabHeaderModule,
  TabFooterWidget: TabFooterModule,
  TabElementWidget: TabElementModule,
  TabWrapper: TabsModule,
  Tab: TabModule,
  ContentAdvantageWidget: ContentAdvantageModule,
  PFModelSelectionWidget: ModelSelectionModule,
  TeaserModulWidget: TeaserModule,
  BranchenAnchorWidget: BranchenAnchorModule,
  PFModelSelectionFilterWidget: ModelSelectionFilterModule,
  PFTypeSelectionWidget: TypeSelectionModule,
  KachelPreviewWidget: KachelPreviewModule,
  NoticeWidget: NoticeModule,
  KeyFiguresWidget: KeyFiguresModule,
  PFDashboardWidget: PfDashboardModule,
  PFKatalogTabelleWidget: KatalogTabelleModule,
  PFKatalogSelectionWidget: KatalogSelectionModule,
  OrganizationChartWidget: OrganizationChartModule,
  NewsListWidget: NewsListModule,
  CWTextBildWidget: CwTextBildModule,
  PFKatalogAufbaurichtlinienWidget: PfKatalogAufbaurichtlinienModule,
  NewsPreviewWidget: NewsPreviewModule,
  StickyAnchorWidget: StickyAnchorModule,
  // 'NewsPreviewWidget': NewsPreviewModule,
  CWProductListVanSolutionWidget: ProductListVanSolutionModule,
  CWProductListVanPartnerWidget: ProductListVanPartnerModule,
  TableWidget: TableModule,
  PFRechtlicheKlausel: RechtlicheKlausel,
  PFRechtlicheKlauselHeaderWidget: RechtlicheKlauselHeader,
  PFRechtlicheKlauselFooterWidget: RechtlicheKlauselFooter,
  PFRechtlicheKlauselSeparatorWidget: RechtlicheKlauselSeparator,
  CkdFileexchangeWidget: FileExchangeModule,
  BreadcrumbWidget: BreadcrumbModule,
  BreadcrumbKatalogWidget: BreadcrumbKatalogModule,
  NextStepNavigationWidget: NextStepNavigationModule,
  CWLandingpageMesseTeaserWidget: CWLandingpageMesseTeaserModul,
  DefaultLayout: DefaultLayout,
  MbvansAufbauPlusLayoutWidget: AufbauplusLayout,
  LoadingLayout: LoadingLayout,
  RechtlicheHinweiseLayoutWidget: RechtlicheHinweiseLayout,
  ReferenceContentWidget: ReferenceContentModule,
  IframeWidget: IframeModule,
  ModalHeader: ModalHeaderModule,
  ModalFooter: ModalFooterModule,
  Modal: ModalModule,
  CWInteriorSpinWidget: CWInteriorSpinWidget,
  PIDetailsWidget: PiDetailsWidget,
  PFWarenkorbWidget: WarenkorbModule,
  FinArchivAbfragenWidget: FinArchivModule,
  UnimogProductFastFilterWidget: ProductFastFilterModule,
  UnimogPageFilterWidget: PageFilterModule,
  UnimogPageProductWidget: PageProductModule,
  UnimogPageABHWidget: PagePartnerModule,
  HaendlersucheWidget: HaendlersucheModule,
  UnimogLayoutWidget: UnimogLayout,
  ModellbeschreibungPflegeWidget: ModellbeschreibungPflegeModule,
  ModellbeschreibungAnzeigeWidget: ModellbeschreibungAnzeigeModule,
  MapWidget: MapModule,
  MatomoOptOutWidget: MatomoOptOutModule,
  CWAbhOverviewPageWidget: AbhOverviewPageModule,
  CWAbhSteckbriefKontaktWidget: AbhSteckbriefKontaktModule,
  CWAbhSteckbriefZertifikateWidget: AbhCertificateModule,
  CWLayoutWidget: ConversionworldLayout,
  CWSeoPortraitWidget: SeoPortraitModule,
  CWAbhSteckbriefFirmenphilosophieWidget: AbhFirmenphilosophieModule,
  CWAbhSteckbriefProdukteWidget: AbhProductsModule,
  CWAbhSteckbriefErfahrungsberichtWidget: AbhReportsModule,
  CWProduktTextWidget: ProductTextModule,
  CWBranchenEinstiegWidget: BranchenEinstiegModule,
  CWFilterWidget: FilterModule,
  CWStageProduktWidget: ProductStageModule,
  CWStageSoftkonfiguratorWidget: StageSoftConfiguratorModule,
  CWTechnischeDatenWidget: ProductTechnicalData,
  CWNextStepProductNavigationWidget: ProductNextStepNavigationModule,
  CWProduktVorteileWidget: ProductAdvantagesModule,
  CWMindestausstattungWidget: ProductMinimumEquipmentModule,
  CWProductAdvantageAutomaticWidget: ProductPartnerAdvantagesAutomaticModule,
  CWProductAdvantageManualWidget: ProductPartnerAdvantagesManuelModule,
  CWProductAdvantageEditWidget: ProductPartnerAdvantagesEditModule,
  CWHerstellerTeaserWidget: ProductBodybuilderTeaserModule,
  CWSeoProduktWidget: SeoProductModule,
  CWPopularSolutionWidget: PopularSolutionModule,
  CWSearchLayerResultWidget: SearchResultModule,
  CWStageFallbackStartseiteWidget: StageFallbackFrontpageModule,
  CWStageFrontpageAnimationWidget: StageFrontpageAnimationModule,
  CWStageBrancheWidget: StageBrancheModule,
  CWErfahrungsberichtWidget: ReportsModule,
  CWStoryInformationWidget: ReportInformationModule,
  CWSeoErfahrungsberichtWidget: SeoReportModule,
  CWNBAStoryWidget: ReportNbaModule,
  CWTeaserWidget: CWTeaserModule,
  CWKonsiListWidget: KonsiListModule,
  CWKonsiSliderWidget: KonsiSliderModule,
  CWSeoMesseWidget: SeoMesseModule,
  HistoryWidget: HistoryModule,
});
